module.exports = __webpack_public_path__ + "img/logo.88bebf3b.png";